<template>
<div class="profesor">
    <vs-table ref="tabla_asignacion_bloques" class="unset-min-width left-footer-unset-radius left-header-unset-radius mt-5">
        <template #thead>
            <vs-tr>
                <vs-th>
                    Profesor
                </vs-th>
                <vs-th>
                    Materia
                </vs-th>
            </vs-tr>
        </template>
        <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in tablaData"
                :data="tr"
            >
                <vs-td>
                    <p class="mb-0"><strong>{{tr.nombre}}</strong></p>
                    <p class="mb-0"><small style="text-transform: uppercase;">salón: </small><strong>{{tr.salon}}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{tr.materia}}</strong></p>
                </vs-td>
            </vs-tr>
        </template>
        <template #notFound>
            No hay registros
        </template>

        <template #footer>
            <vs-pagination v-model="page" :length="pages" />           
        </template>
    </vs-table>
</div>
</template>

<script>
import bloques from '../../../../api/requests/asignar-bloques.js'
import academico from '../../../../api/requests/academico'
export default {
    props:[
        'value',
        'listNiveles',
        'listCiclos',
        'institucion',
        'cicloEscolar',
        'nivelAcademico',
        'grupo',
        'programa',
        'nombre',
        'bloque',
        'ejecutar'
    ],   
    data () {
        return {
            allCheck: false,
            tablaData: [],
            alumnos:[],
            oldIds:[],
            oldDetail:{},
            page: 1, 
            max: 5,
            pages: 1, 
        }
    },
    methods: {
        async openLoading(promise) {
          let loading 
          try {
            loading = this.$vs.loading({
                target: this.$refs.tabla_asignacion_bloques,
                color: 'dark'
            })
            const data = await promise
            loading.close()
            return data
          } catch (error) {
            if (loading){
                loading.close()
            }
            throw error
          }
          
        },
        async tablaCodigos () {
            try {
                let params = {
                    bloque_id: this.bloque
                }
                const { data: response} = await this.openLoading(academico.profesoresGA(params))
                const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                this.pages = Math.ceil(total/per_page) || 0
                this.tablaData = response
            } catch (error) {
                this.tablaData = []
                this.pages = 1
            }
        },
    },
    watch:{
        page () {
            this.tablaCodigos()
        },
        ejecutar () {
            this.tablaCodigos()
        },
    }
}
</script>


<style>
.profesor .vs-table-content .vs-table__footer{
    margin: 2% !important;
}
</style> 